module.exports = __webpack_public_path__ + "assets/img/bg-line-driver-b380e028.png";